<template>
  <div>
    上传厂商证书
  </div>
</template>
<script>
  import axios from 'axios'
  import { baseurl } from '../../api/url'
  export default{

  }
</script>



// WEBPACK FOOTER //
// certUpload.vue?41be0b28